import type { FieldRegistryConfig } from "../../types";
import type { TeamFieldValue, TeamFormValue } from "./team.config";

/**
 * Lives apart from the field config so the control can use it without importing the config,
 * which imports the control.
 */
export const prefillTeam: NonNullable<
  FieldRegistryConfig<TeamFormValue[], TeamFieldValue>["prefill"]
> = ({ value, field, members }) => {
  const teamIds = value.split(",");

  const selectedTeams = members?.filter(
    (team) => teamIds.includes(team.id.toString()) || teamIds.includes(team.name),
  );

  if (!selectedTeams?.length || !members?.length) return null;

  if (field.params.entries_allowed === "multiple") {
    return selectedTeams;
  }

  return [selectedTeams[0]];
};
